module.exports = __webpack_public_path__ + "static/media/home-carousel3.ed8c77f7.webp";